
// This file is automatically generated by git.version.ts script
// Generated on: 2026-10-20T14:22:42.070Z

/**
 * Application version information from git
 */
export const AppVersion = {
    version: '1.1.4',
    revision: 'adae3fc',
    branch: 'main',
    tags: '',
    commitedAt: '2026-10-20 16:21:49 +0200'
} as const;
